import React from 'react'
import Button from '@material-ui/core/Button'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Grow from '@material-ui/core/Grow'
import Paper from '@material-ui/core/Paper'
import Popper from '@material-ui/core/Popper'
import MenuItem from '@material-ui/core/MenuItem'
import MenuList from '@material-ui/core/MenuList'
import { ReactComponent as ArrowDown } from 'src/assets/icon/arrow-down-icon.svg'
import { ReactComponent as ArrowUp } from 'src/assets/icon/arrow-up-icon.svg'
import { UserInfo } from './model'
// import { useLanguage } from 'src/core/components/LanguageProvider/hooks'
import authConfig from 'src/utils/authConfig'
import { ResetPasswordType } from 'src/pages/model'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import useGetAccountPermission from 'src/shared/services/getAccountPermission/hooks'
import { useAlertMachine } from 'src/shared/machine/alertMachine/hooks'
import Alert from 'src/shared/components/Alert'
import useGetOrderLens from 'src/pages/Cart/services/getOrderLens/hooks'
import useStyles from './useStyles'

const AccountDropDown = () => {
  // const { language } = useLanguage()
  const { t } = useTranslation()
  // const isChinese = language === 'zh-TW'
  const { data: permission } = useGetAccountPermission()
  const company_type = permission?.data.result_data.company_model
  const customer_id = permission?.data.result_data.customer_id
  const userData: string | null = window.localStorage.getItem('authenticatedUser')
  const userInfo: UserInfo | null = userData ? JSON.parse(userData) : null
  // const avatarWord = isChinese ? userInfo?.user_name_ch.slice(0, 1) : userInfo?.user_name_en.slice(0, 1)
  // const avatarWord = userInfo?.user_name_ch.slice(0, 1)
  // const classes = useStyles({ word: avatarWord })
  const classes = useStyles()
  const [open, setOpen] = React.useState(false)
  const anchorRef = React.useRef<HTMLButtonElement>(null)
  const { setIsPasswordOpen } = React.useContext(ResetPasswordType)
  const history = useHistory()
  const hasAccQry = permission?.data.result_data.premissions.includes('acc:qry')
  const { openAlert, closeAlert, isAlertOpen, alertMessage } = useAlertMachine()
  const { data: orderLensData = [] } = useGetOrderLens()

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event: React.MouseEvent<EventTarget>) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return
    }

    setOpen(false)
  }

  const modifyPassword = (event: React.MouseEvent<EventTarget>) => {
    handleClose(event)
    setIsPasswordOpen && setIsPasswordOpen(true)
  }

  function handleListKeyDown(event: React.KeyboardEvent) {
    if (event.key === 'Tab') {
      event.preventDefault()
      setOpen(false)
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open)
  React.useEffect(() => {
    if (anchorRef.current !== null && prevOpen.current === true && open === false) {
      anchorRef.current.focus()
    }

    prevOpen.current = open
  }, [open])

  function Logout() {
    if (orderLensData.length >= 1) {
      openAlert({
        title: t('admin.logoutAlert1'),
        content: t('admin.logoutAlert2') + orderLensData.length,
        isDicidedMode: true,
        height: 210,
        onConfirm: () => {
          authConfig.logOut()
        },
      })
    } else {
      authConfig.logOut()
    }
  }

  return (
    <div className={classes.root}>
      <Alert
        isDicidedMode={alertMessage.isDicidedMode as boolean}
        onConfirm={alertMessage.onConfirm}
        onClose={closeAlert}
        open={isAlertOpen}
        title={alertMessage.title}
        content={alertMessage.content}
        height={alertMessage.height}
      />
      <Button
        className={classes.button}
        ref={anchorRef}
        aria-controls={open ? 'menu-list-grow' : undefined}
        aria-haspopup='true'
        disableRipple={true}
        onClick={handleToggle}
      >
        <div className={classes.account}>
          {/* <div className={classes.avatar}>{avatarWord}</div> */}
          {/* <div className={classes.name}>{isChinese ? userInfo?.user_name_ch : userInfo?.user_name_en}</div> */}
          <div className={classes.name}>{userInfo?.user_name_ch}</div>
          {!!open ? <ArrowUp className={classes.arrowDown} /> : <ArrowDown className={classes.arrowDown} />}
        </div>
      </Button>
      <Popper style={{ zIndex: 2 }} open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
        {({ TransitionProps, placement }) => (
          <Grow {...TransitionProps} style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem={open} id='menu-list-grow' onKeyDown={handleListKeyDown}>
                  <MenuItem className={classes.menuItem} onClick={() => history.push('/pages/account-info')}>
                    {t('admin.info')}
                  </MenuItem>
                  <MenuItem className={classes.menuItem} onClick={modifyPassword}>
                    {t('admin2')}
                  </MenuItem>
                  {hasAccQry && (
                    <MenuItem
                      className={classes.menuItem}
                      onClick={() =>
                        (window.location.href = company_type === '1' ? '/account-management' : `/account-management/dealer/${customer_id}`)
                      }
                    >
                      {t('admin4')}
                    </MenuItem>
                  )}
                  <MenuItem className={classes.menuItem} onClick={Logout}>
                    {t('admin3')}
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  )
}

export default AccountDropDown
